import { render, staticRenderFns } from "./Solution.vue?vue&type=template&id=47ad6536&"
import script from "./Solution.vue?vue&type=script&lang=js&"
export * from "./Solution.vue?vue&type=script&lang=js&"
import style0 from "./Solution.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports